/**
 * Excel 風スプレッドシート UI
 * web LP Step4 で静的に表示する Excel プレビュー
 */
import { FONT_FAMILY } from "../lib/fonts";

// 表示する列（本番18列から視認性重視で7列に絞る）
const EXCEL_COLUMNS = [
  { header: "候補者名", width: 120 },
  { header: "現職", width: 140 },
  { header: "所属企業", width: 170 },
  { header: "総合マッチレベル", width: 120 },
  { header: "マッチ必須スキル", width: 200 },
  { header: "スカウト送信判断", width: 130 },
  { header: "スキルチェック実行日時", width: 150 },
] as const;

// ダミーデータ行（20行）
const EXCEL_ROWS: string[][] = [
  [
    "38歳 男性 東京都",
    "VP of Engineering",
    "株式会社グローバルテック",
    "Level 4",
    "React, TypeScript, AWS",
    "送信対象",
    "2024-03-22 10:00:00",
  ],
  [
    "28歳 女性 大阪府",
    "フロントエンドエンジニア",
    "合同会社デジタルラボ",
    "Level 3",
    "React, TypeScript, Next.js",
    "未決定",
    "2024-03-21 09:00:00",
  ],
  [
    "35歳 男性 東京都",
    "テックリード",
    "株式会社クラウドテック",
    "Level 5",
    "Go, Kubernetes, AWS, GraphQL",
    "送信済み",
    "2024-03-23 11:00:00",
  ],
  [
    "41歳 男性 神奈川県",
    "エンジニアリングマネージャー",
    "株式会社シナジー",
    "Level 4",
    "TypeScript, AWS, Terraform",
    "送信対象",
    "2024-03-20 14:30:00",
  ],
  [
    "33歳 女性 東京都",
    "シニアバックエンドエンジニア",
    "株式会社プロダクトベース",
    "Level 4",
    "Go, PostgreSQL, AWS",
    "保留",
    "2024-03-19 16:45:00",
  ],
  [
    "30歳 男性 福岡県",
    "バックエンドエンジニア",
    "株式会社ヒノデソフト",
    "Level 3",
    "Java, Spring Boot, MySQL",
    "未決定",
    "2024-03-18 13:20:00",
  ],
  [
    "44歳 男性 東京都",
    "プロダクトマネージャー",
    "株式会社アトラスワークス",
    "Level 5",
    "Product Strategy, SQL, BI",
    "送信対象",
    "2024-03-18 09:45:00",
  ],
  [
    "27歳 女性 京都府",
    "QAエンジニア",
    "合同会社テストラボ",
    "Level 2",
    "Playwright, TypeScript",
    "送信しない",
    "2024-03-17 17:10:00",
  ],
  [
    "39歳 男性 東京都",
    "SREリード",
    "株式会社インフラベース",
    "Level 5",
    "Kubernetes, Terraform, AWS",
    "送信済み",
    "2024-03-17 11:00:00",
  ],
  [
    "32歳 男性 千葉県",
    "フルスタックエンジニア",
    "株式会社ノースゲート",
    "Level 4",
    "Next.js, NestJS, PostgreSQL",
    "送信対象",
    "2024-03-16 15:30:00",
  ],
  [
    "36歳 女性 東京都",
    "データエンジニア",
    "株式会社データブリッジ",
    "Level 4",
    "Python, BigQuery, dbt",
    "未決定",
    "2024-03-16 10:15:00",
  ],
  [
    "29歳 男性 大阪府",
    "モバイルアプリエンジニア",
    "合同会社ポケットラボ",
    "Level 3",
    "Swift, Kotlin, Flutter",
    "保留",
    "2024-03-15 14:55:00",
  ],
  [
    "47歳 男性 神奈川県",
    "CTO",
    "株式会社サンライズシステム",
    "Level 5",
    "Architecture, AWS, Leadership",
    "送信済み",
    "2024-03-15 09:00:00",
  ],
  [
    "31歳 女性 愛知県",
    "デザインエンジニア",
    "株式会社ミラージュデザイン",
    "Level 3",
    "Figma, React, Tailwind CSS",
    "送信対象",
    "2024-03-14 16:40:00",
  ],
  [
    "34歳 男性 東京都",
    "プラットフォームエンジニア",
    "株式会社グリッドフォース",
    "Level 4",
    "Go, gRPC, Kubernetes",
    "未決定",
    "2024-03-14 13:25:00",
  ],
  [
    "26歳 女性 福岡県",
    "ジュニアエンジニア",
    "合同会社スプラウト",
    "Level 2",
    "TypeScript, React",
    "送信しない",
    "2024-03-13 18:05:00",
  ],
  [
    "42歳 男性 北海道",
    "エンジニアリングマネージャー",
    "株式会社ノースクラウド",
    "Level 4",
    "Team Building, AWS, Scrum",
    "送信対象",
    "2024-03-13 11:50:00",
  ],
  [
    "37歳 女性 東京都",
    "セキュリティエンジニア",
    "株式会社シールドネット",
    "Level 5",
    "Pentest, AWS Security, IAM",
    "送信済み",
    "2024-03-12 15:00:00",
  ],
  [
    "33歳 男性 兵庫県",
    "DevOpsエンジニア",
    "株式会社オーロラテック",
    "Level 4",
    "GitHub Actions, Docker, AWS",
    "保留",
    "2024-03-12 09:30:00",
  ],
  [
    "45歳 男性 東京都",
    "VPoP",
    "株式会社ブルーフロンティア",
    "Level 5",
    "Product Vision, OKR, Strategy",
    "送信対象",
    "2024-03-11 14:20:00",
  ],
];

const HEADER_BG = "#217346"; // Excel green
const HEADER_TEXT = "#FFFFFF";
const GRID_LINE = "#D4D4D4";
const ROW_NUMBER_BG = "#F2F2F2";
const ROW_NUMBER_TEXT = "#616161";
const ROW_HEIGHT = 36;
const COLUMN_HEADER_HEIGHT = 28;
const ROW_NUMBER_WIDTH = 44;

const COLUMN_LETTERS = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"];

type ExcelGridProps = {
  fileName: string;
};

export const ExcelGrid: React.FC<ExcelGridProps> = ({ fileName }) => {
  const totalGridWidth =
    ROW_NUMBER_WIDTH + EXCEL_COLUMNS.reduce((sum, col) => sum + col.width, 0);

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#FFFFFF",
        fontFamily: FONT_FAMILY,
        fontSize: 13,
        color: "#1F1F1F",
        overflow: "hidden",
      }}
    >
      {/* Excel タイトルバー */}
      <div
        style={{
          height: 36,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          backgroundColor: "#F3F3F3",
          borderBottom: `1px solid ${GRID_LINE}`,
          padding: "0 16px",
          flexShrink: 0,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div
            style={{
              width: 18,
              height: 18,
              borderRadius: 3,
              backgroundColor: HEADER_BG,
              color: "#FFFFFF",
              fontWeight: 700,
              fontSize: 11,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            X
          </div>
          <span style={{ fontSize: 13, color: "#1F1F1F", fontWeight: 500 }}>
            {fileName} - Excel
          </span>
        </div>
        <div style={{ display: "flex", gap: 12, fontSize: 11, color: "#616161" }}>
          <span>ホーム</span>
          <span>挿入</span>
          <span>ページレイアウト</span>
          <span>数式</span>
          <span>データ</span>
        </div>
      </div>

      {/* リボン擬似 */}
      <div
        style={{
          height: 32,
          display: "flex",
          alignItems: "center",
          gap: 12,
          backgroundColor: "#FAFAFA",
          borderBottom: `1px solid ${GRID_LINE}`,
          padding: "0 16px",
          fontSize: 11,
          color: "#3C3C3C",
          flexShrink: 0,
        }}
      >
        <span>BIU</span>
        <span style={{ color: "#9E9E9E" }}>|</span>
        <span>フォント</span>
        <span style={{ color: "#9E9E9E" }}>|</span>
        <span>配置</span>
        <span style={{ color: "#9E9E9E" }}>|</span>
        <span>セルの書式</span>
      </div>

      {/* 数式バー */}
      <div
        style={{
          height: 26,
          display: "flex",
          alignItems: "center",
          gap: 8,
          backgroundColor: "#FFFFFF",
          borderBottom: `1px solid ${GRID_LINE}`,
          padding: "0 12px",
          fontSize: 12,
          color: "#3C3C3C",
          flexShrink: 0,
        }}
      >
        <span
          style={{
            width: 60,
            border: `1px solid ${GRID_LINE}`,
            padding: "2px 6px",
            fontSize: 11,
          }}
        >
          A1
        </span>
        <span style={{ color: "#9E9E9E" }}>fx</span>
        <span style={{ color: "#1F1F1F" }}>候補者名</span>
      </div>

      {/* シート本体（横スクロール対応） */}
      <div style={{ flex: 1, overflow: "hidden", backgroundColor: "#FFFFFF" }}>
        <div style={{ width: totalGridWidth }}>
          {/* 列ヘッダー A/B/C/... */}
          <div style={{ display: "flex", height: COLUMN_HEADER_HEIGHT, flexShrink: 0 }}>
            <div
              style={{
                width: ROW_NUMBER_WIDTH,
                backgroundColor: ROW_NUMBER_BG,
                borderRight: `1px solid ${GRID_LINE}`,
                borderBottom: `1px solid ${GRID_LINE}`,
              }}
            />
            {EXCEL_COLUMNS.map((col, idx) => (
              <div
                key={col.header}
                style={{
                  width: col.width,
                  height: COLUMN_HEADER_HEIGHT,
                  backgroundColor: ROW_NUMBER_BG,
                  borderRight: `1px solid ${GRID_LINE}`,
                  borderBottom: `1px solid ${GRID_LINE}`,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 11,
                  fontWeight: 600,
                  color: ROW_NUMBER_TEXT,
                }}
              >
                {COLUMN_LETTERS[idx]}
              </div>
            ))}
          </div>

          {/* ヘッダー行 (Excel上は1行目) */}
          <div style={{ display: "flex", height: ROW_HEIGHT, flexShrink: 0 }}>
            <div
              style={{
                width: ROW_NUMBER_WIDTH,
                backgroundColor: ROW_NUMBER_BG,
                borderRight: `1px solid ${GRID_LINE}`,
                borderBottom: `1px solid ${GRID_LINE}`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 11,
                fontWeight: 600,
                color: ROW_NUMBER_TEXT,
              }}
            >
              1
            </div>
            {EXCEL_COLUMNS.map((col) => (
              <div
                key={col.header}
                style={{
                  width: col.width,
                  height: ROW_HEIGHT,
                  backgroundColor: HEADER_BG,
                  color: HEADER_TEXT,
                  borderRight: `1px solid ${GRID_LINE}`,
                  borderBottom: `1px solid ${GRID_LINE}`,
                  display: "flex",
                  alignItems: "center",
                  padding: "0 10px",
                  fontWeight: 600,
                  fontSize: 12,
                }}
              >
                {col.header}
              </div>
            ))}
          </div>

          {/* データ行 */}
          {EXCEL_ROWS.map((row, rowIdx) => (
            <div
              key={`row-${rowIdx + 2}`}
              style={{ display: "flex", height: ROW_HEIGHT, flexShrink: 0 }}
            >
              <div
                style={{
                  width: ROW_NUMBER_WIDTH,
                  backgroundColor: ROW_NUMBER_BG,
                  borderRight: `1px solid ${GRID_LINE}`,
                  borderBottom: `1px solid ${GRID_LINE}`,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 11,
                  fontWeight: 600,
                  color: ROW_NUMBER_TEXT,
                }}
              >
                {rowIdx + 2}
              </div>
              {row.map((cell, cellIdx) => (
                <div
                  key={`${rowIdx}-${cellIdx}`}
                  style={{
                    width: EXCEL_COLUMNS[cellIdx].width,
                    height: ROW_HEIGHT,
                    borderRight: `1px solid ${GRID_LINE}`,
                    borderBottom: `1px solid ${GRID_LINE}`,
                    display: "flex",
                    alignItems: "center",
                    padding: "0 10px",
                    fontSize: 12,
                    color: "#1F1F1F",
                    backgroundColor: "#FFFFFF",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {cell}
                </div>
              ))}
            </div>
          ))}

        </div>
      </div>

      {/* シートタブ */}
      <div
        style={{
          height: 28,
          backgroundColor: "#F3F3F3",
          borderTop: `1px solid ${GRID_LINE}`,
          display: "flex",
          alignItems: "center",
          padding: "0 12px",
          gap: 8,
          flexShrink: 0,
        }}
      >
        <div
          style={{
            backgroundColor: "#FFFFFF",
            borderTop: `2px solid ${HEADER_BG}`,
            borderLeft: `1px solid ${GRID_LINE}`,
            borderRight: `1px solid ${GRID_LINE}`,
            padding: "4px 12px",
            fontSize: 12,
            fontWeight: 500,
            color: "#1F1F1F",
          }}
        >
          エクスポート
        </div>
        <div
          style={{
            padding: "4px 12px",
            fontSize: 12,
            color: "#9E9E9E",
          }}
        >
          +
        </div>
      </div>
    </div>
  );
};
